import { shortNews } from '@/mocks/homeData';

export default function ShortNewsStrip() {
  return (
    <div className="rounded-lg border border-background-300 bg-background-50 overflow-hidden">
      <div className="flex items-center gap-3 px-5 py-3 border-b border-background-200 bg-background-100">
        <span className="w-5 h-5 flex items-center justify-center text-accent-600">
          <i className="ri-flashlight-line text-lg"></i>
        </span>
        <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950">短讯速览</h3>
        <span className="text-[11px] text-foreground-500 font-label">滚动更新的零散线索</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 divide-y md:divide-y-0 divide-background-200">
        {shortNews.map((item, idx) => (
          <a
            key={item.id}
            href="#feed"
            className={`block px-5 py-4 hover:bg-background-100 transition-colors ${
              idx % 2 === 0 ? 'md:border-r md:border-background-200' : ''
            } ${idx < 2 ? 'md:border-b md:border-background-200' : ''}`}
          >
            <div className="flex items-center gap-2">
              <span className="h-5 px-2 inline-flex items-center rounded bg-secondary-100 text-secondary-900 text-[11px] font-label">{item.tag}</span>
              <span className="text-[11px] text-foreground-500 font-label">{item.meta}</span>
            </div>
            <p className="mt-2 text-sm leading-snug text-foreground-800 font-body">{item.title}</p>
          </a>
        ))}
      </div>
    </div>
  );
}